import { Subscription, Subject } from "rxjs";

export class StoreResponse<T> {

  requestId: number;

  data: T;

}